function updateFieldsContainerVisibility() {
  const fieldsContainer = document.querySelector('.js-fields_container')
  const overlayContainer = document.querySelector('.js-goals_overlay_container')
  const toggleCheckbox = document.querySelector('.js-toggle_goals_enabled')
  const overlay = document.querySelector('.js-goals_overlay')

  if (toggleCheckbox.checked) {
    fieldsContainer.style.display = 'block'
    overlayContainer.classList.remove('backend_publication_goals__overlay_container--disabled')
    overlay.style.display = 'none'
  } else {
    fieldsContainer.style.display = 'none'
    overlayContainer.classList.add('backend_publication_goals__overlay_container--disabled')
    overlay.style.display = 'block'
  }
}

up.compiler('.js-toggle_goals_enabled', function () {
  updateFieldsContainerVisibility()

  const toggle = document.querySelector('.js-toggle_goals_enabled')
  toggle.addEventListener('change', async function () {
    const form = toggle.closest('form')
    const url = form.getAttribute('action')
    const method = form.getAttribute('method')
    const body = new FormData(form)

    await fetch(url, {
      method,
      body,
      credentials: 'same-origin'
    })

    updateFieldsContainerVisibility()
  })
})
